import { Space } from 'antd';
import styled from 'styled-components';

export const ArrowWrapper = styled(Space)`
  &.open {
    .arrow-left {
      transform: rotateZ(-40deg) translate(0.6px, 0.6px);
    }
    .arrow-right {
      transform: rotateZ(40deg) translate(-0.6px, 0.6px);
    }
  }

  .arrow {
    height: 1.5px;
    width: 6.8px;
    border-radius: 2px;

    transition: all 0.3s ease;
  }
  .arrow-left {
    transform: rotateZ(40deg) translate(0.6px, -0.6px);
  }
  .arrow-right {
    transform: rotateZ(-40deg) translate(-0.6px, -0.6px);
  }
`;
